module.exports = __webpack_public_path__ + "static/img/aigc-brand-logo.4cc8def.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/aigc/assets/aigc-brand-logo.png
// module id = X7Kx
// module chunks = 130